export const weeks = {
    "1":"日",
    "2":"一",
    "3":"二",
    "4":"三",
    "5":"四",
    "6":"五",
    "7":"六"
}